// Entry point for the build script in your package.json
import "./popper.min.js"
import "bootstrap"
import { Tooltip, Popover } from 'bootstrap';
import "@hotwired/turbo-rails"
import "./controllers"
import "./react/src/index.js"
import "./add_jquery"
import "./registration_wells"
import "./initialize_dragdrop"
// import "./submission_show.js"
import Odometer from "odometer"

import LocalTime from "local-time"
LocalTime.start()
// import "/home/sukanta/wishartlab/lcauto/lc-autofit-rails/node_modules/odometer/sass/odometer-theme-default.sass"
// import "./channels/progress_consumer"

window.luxon = require('luxon');

// console.log("Hello from app/javascript/application.js")
// subscribeToProgressChannel()


import Rails from "@rails/ujs"
Rails.start()

// add submission_show.js if controller is submissions
if (window.location.pathname.includes("/submissions/")) {
    import("./submission_show.js")
}

// Store tooltip instances for cleanup
let activeTooltips = [];
let activePopovers = [];

/**
 * Build a Popper config that compensates for CSS zoom on <body>.
 *
 * Problem: the app sets `zoom: 0.8` on body. Popper reads element positions
 * via getBoundingClientRect() (viewport / screen coords) but writes CSS
 * transform values that are ALSO subject to zoom. The result is every tooltip
 * and popover appears offset from its trigger.
 *
 * Fix: after Popper's computeStyles modifier generates the final CSS
 * transform, divide the translate values by the zoom factor so that
 * `cssValue * zoom === intendedScreenPosition`.
 */
function zoomAwarePopperConfig(defaultConfig) {
    const zoomLevel = parseFloat(getComputedStyle(document.body).zoom) || 1;
    if (zoomLevel === 1) return defaultConfig;

    return {
        ...defaultConfig,
        modifiers: [
            ...(defaultConfig.modifiers || []),
            {
                name: 'zoomFix',
                enabled: true,
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                fn({ state }) {
                    // Adjust a translate transform string by dividing x/y by zoom
                    function adjust(transform) {
                        if (!transform) return transform;
                        return transform.replace(
                            /translate(3d)?\(([^)]+)\)/,
                            (_match, is3d, coords) => {
                                const parts = coords.split(',').map(s => s.trim());
                                const fixed = parts.map((part, i) => {
                                    if (i < 2) {
                                        const v = parseFloat(part);
                                        if (!isNaN(v)) return `${Math.round(v / zoomLevel)}px`;
                                    }
                                    return part;
                                });
                                return `translate${is3d || ''}(${fixed.join(', ')})`;
                            }
                        );
                    }

                    // --- tooltip / popover element -----------------------
                    if (state.styles.popper) {
                        if (state.styles.popper.transform) {
                            state.styles.popper.transform = adjust(state.styles.popper.transform);
                        }
                        // Fallback: gpuAcceleration disabled → top/left used instead of transform
                        ['left', 'top'].forEach(prop => {
                            const val = state.styles.popper[prop];
                            if (val && val !== '0' && val !== '0px') {
                                const n = parseFloat(val);
                                if (!isNaN(n)) state.styles.popper[prop] = `${Math.round(n / zoomLevel)}px`;
                            }
                        });
                    }

                    // --- arrow element -----------------------------------
                    if (state.styles.arrow) {
                        if (state.styles.arrow.transform) {
                            state.styles.arrow.transform = adjust(state.styles.arrow.transform);
                        }
                        ['left', 'top'].forEach(prop => {
                            const val = state.styles.arrow[prop];
                            if (val && val !== '0' && val !== '0px') {
                                const n = parseFloat(val);
                                if (!isNaN(n)) state.styles.arrow[prop] = `${Math.round(n / zoomLevel)}px`;
                            }
                        });
                    }
                },
            },
        ],
    };
}

// Dispose tooltips before Turbo caches the page
document.addEventListener("turbo:before-cache", function () {
    activeTooltips.forEach(t => { try { t.dispose(); } catch (_) { } });
    activeTooltips = [];
    activePopovers.forEach(p => { try { p.dispose(); } catch (_) { } });
    activePopovers = [];
});

document.addEventListener("turbo:load", function () {
    // Dispose any existing instances first
    activeTooltips.forEach(t => { try { t.dispose(); } catch (_) { } });
    activeTooltips = [];
    activePopovers.forEach(p => { try { p.dispose(); } catch (_) { } });
    activePopovers = [];

    // --- Bootstrap Tooltips -----------------------------------------------
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    activeTooltips = [...tooltipTriggerList].map(el => new Tooltip(el, {
        html: true,
        trigger: 'hover',
        popperConfig: zoomAwarePopperConfig,
    }));

    // --- Bootstrap Popovers -----------------------------------------------
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    activePopovers = [...popoverTriggerList].map(el => new Popover(el, {
        html: true,
        sanitize: false,
        popperConfig: zoomAwarePopperConfig,
    }));

    const pathName = window.location.pathname
    const segments = pathName.split("/").filter(segment => segment !== "");
    const analyteID = segments[segments.length - 1]
    $('tr[id^="analyte-selection-row-"]').each(function () {
        if ($(this).attr('id') === `analyte-selection-row-${analyteID}`) {
            $(this).addClass('table-primary');  // color the selected analyte
            const timer = setTimeout(() => {
                document.getElementById($(this).attr('id')).scrollIntoView({ block: "center", inline: "center" });
            }, 500)
        };
    });
})


import '../../node_modules/gridstack/dist/gridstack.css';
import '../../node_modules/gridstack/dist/gridstack-extra.css';
import { GridStack } from 'gridstack';


document.addEventListener("turbo:load", function () {
    console.log("Hello from app/javascript/kit_grid.js")
    // var options = {
    //     cellHeight: 80,
    //     verticalMargin: 10
    // };
    // var grid = GridStack.init(options);
    // grid.addWidget('<div class="grid-stack-item"><div class="grid-stack" style="background-color: #ffa500;">Double Blank</div></div>', 0, 0, 1, 1, true);
    // grid.addWidget('<div class="grid-stack-item"><div class="grid-stack" style="background-color: #8a2be2;">Blank</div></div>', 1, 0, 2, 1, true);
    let mainGrid = document.getElementById('main-grid');
    let gridHeight = mainGrid.offsetHeight;
    let numRows = 8
    let padding = 0.2; // Padding bottom from last row to the bottom of the grid
    let cellHeight = Math.floor(gridHeight / numRows) - padding; // Calculate cell height based on grid height and number of rows
    console.log("Grid height:", gridHeight, "Cell height:", cellHeight);
    let options = {
        float: false,
        cellHeight: cellHeight,

    }
    GridStack.init(options);


})


// ------------------------------------
// Shared slideshow helper
// ------------------------------------
function initSlideshow(containerSel, slideSel, dotSel, interval) {
    const container = document.querySelector(containerSel);
    if (!container) return;

    const slides = container.querySelectorAll(slideSel);
    const dots = document.querySelectorAll(dotSel);
    if (slides.length < 2) return;

    let current = Array.from(slides).findIndex(s => s.classList.contains('active'));
    if (current === -1) current = 0;

    function goTo(index) {
        slides[current].classList.remove('active');
        dots[current]?.classList.remove('active');
        current = ((index % slides.length) + slides.length) % slides.length;
        slides[current].classList.add('active');
        dots[current]?.classList.add('active');
    }

    setInterval(() => goTo(current + 1), interval);

    dots.forEach(dot => {
        dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.slide);
            if (!isNaN(idx)) goTo(idx);
        });
    });
}

// ------------------------------------
// Shared odometer helper
// ------------------------------------
function initOdometer(elementId, pollUrl, delay) {
    const el = document.getElementById(elementId);
    if (!el) return;

    const targetValue = parseInt(el.dataset.target) || 0;
    el.odometer = undefined;
    el.innerHTML = '';
    el.textContent = '0';

    const od = new Odometer({
        el: el,
        value: 0,
        format: '(,ddd)',
        theme: 'default',
        duration: 2000
    });

    setTimeout(() => od.update(targetValue), delay);

    setInterval(() => {
        fetch(pollUrl)
            .then(r => r.json())
            .then(d => od.update(d.count))
            .catch(() => { });
    }, 5000);
}

// Auth page image slideshow
document.addEventListener("turbo:load", function () {
    initSlideshow('.auth-slideshow', '.auth-slide', '.auth-brand-dots .auth-dot', 4000);
});

// Dashboard slideshow
document.addEventListener("turbo:load", function () {
    initSlideshow('.dash-slideshow', '.dash-slide', '.dash-slideshow-dots .dash-sdot', 5000);
});


document.addEventListener("turbo:load", function () {
    console.log("Hello from app/javascript/odometer.js")
    initOdometer('analyte-count', '/stats/analyte_count', 1000);
    initOdometer('sample-count', '/stats/sample_count', 1200);
});


document.addEventListener("turbo:load", function () {
    if (window.location.pathname.includes("/system_performance_assessment/")) {
        console.log("Importing system_performance_assessment_show.js");
        import("./system_performance_assessment_show.js")
            .then(() => {
                console.log("Successfully imported system_performance_assessment_show.js");
                // Call initialization function each time the page loads
                if (window.initializeSystemPerformanceAssessment) {
                    window.initializeSystemPerformanceAssessment();
                }
            })
            .catch(error => {
                console.error("Failed to import system_performance_assessment_show.js:", error);
            });
    }
})